import { LibraryImage, Slide } from 'components'
import { ItemDataAssentsAll } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { ImageCrop } from './ImageCrop'
import { SlideImageContentProps } from './SlideImageContentProps.type'

export const SlideImageContent: React.FC<SlideImageContentProps> = ({
	slideImages,
	openSlide,
	nameSlide,
	setOpenSlide,
	setSlideImages,
	setNameSlide,
	append,
	watch,
	setValue,
	remove
}): JSX.Element => {
	const [slideLibraryImages, setSlideLibraryImages] = useState(false)
	const [isCropSettingsVisible, setIsCropSettingsVisible] = useState(true)
	const [isFinishCropButtonVisible, setIsFinishCropButtonVisible] =
		useState(true)

	const [sendImageCropped, setSendImageCropped] = useState<
		ItemDataAssentsAll[]
	>([])

	const [listImage, setListImage] = useState<ItemDataAssentsAll[]>([])

	useEffect(() => {
		return () => {
			setListImage([])
			setSendImageCropped([])
		}
	}, [])

	useEffect(() => {
		const assets = watch().assets || []
		const result = assets.map(element => ({
			asset_type: 'image',
			asset_url: element.title
		}))
		setListImage(prev => [...prev, ...result])
	}, [])

	return (
		<div className="flex-col h-full relative">
			<Slide
				title={nameSlide}
				open={openSlide}
				scroll={slideLibraryImages}
				setOpen={setOpenSlide}
				classNameTitle="!font-bold"
				wide={false}
				helper={slideImages}
				titleHelper="Supported formats (JPG, JPEG, PNG). Max image size 10 MB. Min. Resolution: 1080px by 1080px"
			>
				<>
					{slideImages && (
						<ImageCrop
							sendImageCropped={sendImageCropped}
							setSendImageCropped={setSendImageCropped}
							isCropSettingsVisible={isCropSettingsVisible}
							setIsCropSettingsVisible={setIsCropSettingsVisible}
							setIsFinishCropButtonVisible={setIsFinishCropButtonVisible}
							isFinishCropButtonVisible={isFinishCropButtonVisible}
							setOpenSlide={setOpenSlide}
							setSlideImages={state => {
								setNameSlide('Upload an Image')
								setSlideImages(state)
							}}
							setSlideLibraryImages={state => {
								setNameSlide('Add Images From Library')
								setSlideLibraryImages(state)
							}}
							onSubmited={append}
							watch={watch}
							setValue={setValue}
							listImage={listImage}
							setListImage={setListImage}
							remove={remove}
						/>
					)}
					{slideLibraryImages && (
						<LibraryImage
							setSendImageCropped={setSendImageCropped}
							listImage={listImage}
							setOpenSlide={setOpenSlide}
							setListImage={setListImage}
							setSlideImages={state => {
								setNameSlide('Upload an Image')
								setSlideImages(state)
							}}
							setSlideLibraryImages={state => {
								setNameSlide('Upload an Image')
								setSlideLibraryImages(state)
							}}
							libaryType="resources"
						/>
					)}
				</>
			</Slide>
		</div>
	)
}
